export enum RequestTeamTeammateStatusEnum {
  WAITING = 'waiting',
  ACCEPTED = 'accepted',
  REJECTED = 'rejected',
  // REMOVED = 'removed',
  // TIMEOUT = 'timeout',
}
